import React, { useEffect, useMemo, useState } from 'react';
import { Switch } from 'tdesign-react';

import { Frame } from '@/components/icon';
import { labelDom, LabelDomProps } from '@/components/Label';
import { ImageRatio } from '@/const/richMedia';
import { PageIds } from '@/const/tip';
import { VideoImage, VideoImageRole } from '@/interface/aigc';
import { RichMediaValue } from '@/interface/media';
import UploadPic from '@/material/form-upload/image';
import { useTypedSelector } from '@/store';

import styles from './index.module.less';

interface IProps {
  onChange: (key: VideoImage[]) => void;
  value: VideoImage[];
  fieldname: string;
  labelSetting: {
    tipIcon: boolean;
    tipText: string;
  };
  disabled?: boolean;
  required?: boolean;
}

// 首尾帧
const CustomAigcFrame: React.FC<IProps> = ({ value, onChange, labelSetting, disabled = false, ...props }) => {
  const [data, setData] = useState(value);
  const [showLast, setShowLast] = useState<boolean>(false);
  const tipList = useTypedSelector(store => store.tip);

  const firstImage = useMemo(() => value?.find(e => e.role === VideoImageRole.FIRST)?.url || '', [value]);
  const lastImage = useMemo(() => value?.find(e => e.role === VideoImageRole.LAST)?.url || '', [value]);

  useEffect(() => {
    onChange(data);
  }, [data, onChange]);

  const handleOnChange = (role: VideoImageRole, data?: RichMediaValue) => {
    setData(pre => [
      ...(pre?.filter(e => e.role !== role) || []),
      { url: data?.url?.url || '', role },
    ]);
  };

  const handleSwitch = (v: boolean) => {
    setShowLast(v);
    if (!v) {
      setData(pre => pre?.filter(e => e.role !== VideoImageRole.LAST) || []);
    }
  };

  const labelProps: LabelDomProps = {
    field: { labelSetting, props: props.fieldname, ...props },
    initFormData: '',
    requiredItem: props.required,
    pageId: PageIds.AIGC_INFO,
    tipList,
  };

  const uploadProps = {
    disabled,
    isShowAigc: false,
    limit: { ratio: ImageRatio.unlimited },
    contentStyle: { width: '100%', height: '100%' },
    normalDomStyle: { width: '100%', height: '100%' },
    wrapStyle: { width: '100%', height: '100%', border: '1px solid rgba(241, 241, 242, 0.08)', background: 'rgba(255, 255, 255, 0.05)' },
    imageStyle: { width: '100%', height: '100%', maxWidth: '', maxHeight: '' },
  };

  return (
    <div className={styles.container}>
      {labelDom(labelProps)}
      <div className={styles.upload}>
        <UploadPic
          value={{ url: { url: firstImage } }}
          onChange={v => handleOnChange(VideoImageRole.FIRST, v)}
          btnText={showLast ? '上传首帧图片' : '上传图片'}
          {...uploadProps}
        />
        {showLast && (
          <UploadPic
            value={{ url: { url: lastImage } }}
            onChange={v => handleOnChange(VideoImageRole.LAST, v)}
            btnText="上传尾帧图片"
            {...uploadProps}
          />
        )}
        {showLast && <Frame className={styles.frame} />}
      </div>
      <div className={styles.switch}>
        使用尾帧
        <Switch
          value={showLast}
          disabled={disabled}
          onChange={handleSwitch}
          size='small'
        />
      </div>
    </div>
  );
};

export default CustomAigcFrame;
